import { Tab } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tab-select').forEach((tabSelect) => {
    tabSelect.addEventListener('change', (evt) => {
      let selection = evt.currentTarget.selectedOptions[0];
      switch (selection.getAttribute('data-wf-type')) {
        case 'link':
          window.location = selection.value;
        break;
        case 'tab':
          Tab.getOrCreateInstance(document.querySelector(selection.value)).show();
        break;
      }
    })
  })
})